module.exports = __webpack_public_path__ + "img/personal_card.a3f1aa9d.png";